import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { SuggestAdressRequest, SuggestAdressResponse } from '../../types/api/dadata/suggest-adress'

const DADATA_API_TOKEN = '727e31ea3834b6632b98258563ad28f8bb83a3cd'

export const dadataApi = createApi({
    reducerPath: 'dadataApi',
    baseQuery: fetchBaseQuery({
        baseUrl: 'https://suggestions.dadata.ru/suggestions/api/4_1/rs',
        prepareHeaders: headers => {
            headers.set('Content-Type', 'application/json')
            headers.set('Accept', 'application/json')
            headers.set('Authorization', `Token ${DADATA_API_TOKEN}`)
            return headers
        },
    }),
    endpoints: builder => ({
        suggestAddress: builder.query<SuggestAdressResponse, SuggestAdressRequest>({
            query: body => ({
                url: '/suggest/address',
                method: 'POST',  
                body,              
            }),
        }),
    }),
})

export const { useSuggestAddressQuery } = dadataApi